import React, { FC } from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { PersonAppointmentStatus } from 'modules/booking/interfaces';
import {
  AppointmentStatusColors,
  AppointmentStatuses,
} from 'common/components/PersonProfile/constants';

const useStyles = makeStyles(() => ({
  status: {
    textTransform: 'uppercase',
    fontSize: '0.625rem',
    fontWeight: 500,
  },
}));

interface IBookingAppointmentStatus {
  appointmentStatus: PersonAppointmentStatus;
}

const BookingAppointmentStatus: FC<IBookingAppointmentStatus> = ({ appointmentStatus }) => {
  const classes = useStyles();

  return (
    <Typography
      component="span"
      variant="body2"
      style={{ color: AppointmentStatusColors[appointmentStatus] }}
      className={classes.status}
    >
      {AppointmentStatuses.translate(appointmentStatus)}
    </Typography>
  );
};

export default BookingAppointmentStatus;
